<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Featured Offers</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fluid">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-10">
            <div class="isotope-wrapper">
              <div class="box_general padding_bottom">
                
                  <div class="row">
                    <div class="col-md-12 add_top_30">
                      <div class="row">
                         
                      <div class="col-lg-12">
                        <router-link class="btn_1 mb-4" to="featured-add">Add Featured Offer</router-link>
                      </div>
                      </div>
                      
                      <!-- /row-->
                      <table class="table table-striped table-bordered table-sm" cellspacing="0" width="100%" id="table">
                        <thead>
                          <tr>
                            <th>Sr No</th>
                            <th>Offer Name</th>
                            
                            <th>Featured Date</th>
                            <th>Expire Date</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(banner, index) in banners"
                            :key="banner.id"
                          >
                            <th>{{ index + 1 }}</th>
                            <td>
                              {{ banner.short_description }}
                            </td>
                           <td>
                              <strong>{{ frontEndDateFormat(banner.timestamp) }}</strong>
                            </td>
                            <td>
                              <strong>{{ banner.expire_date }}</strong>
                            </td>
                            
                            <td>
                              <strong v-if="banner.expire_date > currentDate"> Active </strong>
                              <strong v-else > Inactive </strong>
                            </td>
                            <td
                              class="options"
                              style="width: 5%; text-align: center"
                            >
                            <!-- <router-link :to=""><i class="fa fa-eye"></i></router-link> -->
                              <a
                                href="javascript:void(0); "><i class="fa fa-eye"></i> </a
                              >&nbsp;&nbsp;
                              <a
                                href="javascript:void(0); "
                                @click="redirect(banner.id, 'delete-offer')"
                                v-show="banner.expire_date < currentDate"
                                ><i class="fa fa-trash"></i
                              ></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- /row-->
                      <!-- /row-->
                    </div>
                  </div>
               
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import moment from "moment";
import $ from "jquery";


export default {
  data() {
    return {
      roleId: localStorage.getItem("role_id"),
      token: "Bearer " + localStorage.getItem("token"),
      msg: null,
      classAlert: null,

      banners:[],
      search: {
        expire_date: '',
        location: "",
        pincode: "",
      },
      searchcat: {
        categories: [],
        subcategories: [],
      },
      datepickerconfig: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: new Date(),
        maxDate: new Date().setMonth(new Date().getMonth() + 1),
      },
      galleryimage: [],
      login_id: null,
      currentDate:'42143',
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
  },
  beforeMount() {
    this.checkToken();
    this.getfeaturedoffer();
    this.todayDate();
  },
  watch: {
    banners() {
      this.dt.destroy();

      this.$nextTick(() => {
        this.dt = $(".table").DataTable();
      });
    },
  },
  
  methods: {
     redirect(offerId,route) {
     let i= window.btoa(offerId)
      this.$router.push(`${route}/${i}`);
    },
    todayDate(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      this.currentDate = mm + '-' + dd + '-' + yyyy;
    },
    checkToken() {
      //alert(this.token);
      if (this.token == "Bearer " + null) {
        this.$router.push("/signin");
      }
    },
   
   
    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    },


    getfeaturedoffer() {
      // alert(this.token);
      const role_id = localStorage.getItem("role_id");
      const form = new FormData();
      form.append("role_id", role_id);
      API.post("/offer/get_featuredoffer_by_vendorId", form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          this.dt = $(".table").DataTable();

          setTimeout(() => (this.banners = res.data.data));
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
 
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.show_img,
.header_box img {
  width: 100%;
}
</style>